import React from "react";
import { Container, Text } from "./Footer.Styled";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Container>
      <Text>© <span suppressHydrationWarning>{year}</span> Viet Hoang Nguyen | All rights reserved.</Text>
    </Container>
  );
};

export default Footer;
